module.exports = __webpack_public_path__ + "img/wait-validation.e5384ef0.svg";